import React from 'react';

const NodeAISVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0.976744C3.67345 0.976744 0.976744 3.67345 0.976744 7C0.976744 7.96444 1.20304 8.87457 1.60499 9.68155C1.7663 10.0054 1.82843 10.3928 1.72664 10.7732L1.3388 12.2227C1.26757 12.4888 1.51113 12.7324 1.77734 12.6612L3.22686 12.2734C3.60727 12.1716 3.99456 12.2337 4.31845 12.395C5.12544 12.797 6.03556 13.0233 7 13.0233C10.3265 13.0233 13.0233 10.3265 13.0233 7C13.0233 3.67345 10.3265 0.976744 7 0.976744ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C5.88111 14 4.8222 13.7371 3.88298 13.2693C3.74283 13.1995 3.59972 13.1847 3.47932 13.2169L2.0298 13.6047C1.03754 13.8702 0.129757 12.9624 0.395256 11.9702L0.783088 10.5207C0.815308 10.4003 0.800494 10.2572 0.730689 10.1171C0.262881 9.17781 0 8.11889 0 7Z"
        fill={color}
      />
      <path d="M9.56306 4.8457V9.24993H8.67969V4.8457H9.56306Z" fill={color} />
      <path
        d="M6.86253 8.41069H5.10841L4.81816 9.24989H3.89062L5.47438 4.83936H6.50287L8.08663 9.24989H7.15278L6.86253 8.41069ZM6.62276 7.70399L5.98547 5.86154L5.34818 7.70399H6.62276Z"
        fill={color}
      />
    </svg>
  );
};

export default NodeAISVG;
